import React from 'react'
import { DetailsViewWrapper, HeaderContent } from '../general'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ExtensionTypes, ExtensionDetailsProps } from '../../types'
import { FooterContent } from './helpers'
import { InexogyLogo } from '../../resources'
import { useTheme } from '@mui/material'
import { isFlowTheme } from 'src/Libs/utils/theme-helpers'

/**
 * Gives a detailed description of the inexogy marketing extension. Also allows to redirect to the partner.
 */
const InexogyDetails: React.FC<ExtensionDetailsProps> = ({ extensionState, isLoading, onClose, place = 0 }) => {
  const { t } = useCustomTranslation()
  const theme = useTheme()
  const description = isFlowTheme
    ? t('installation-extensions.inexogy.modal.description.flow')
    : t('installation-extensions.inexogy.modal.description')
  const contractStateProps = {
    contractState: extensionState,
    isLoading,
  }

  return (
    <DetailsViewWrapper
      extensionType={ExtensionTypes.Inexogy}
      descriptions={[description]}
      headerContent={<HeaderContent logo={<InexogyLogo />} />}
      footerContent={<FooterContent />}
      onClose={onClose}
      place={place}
      open={true}
      category={{ name: 'smart-meter', paletteColor: theme.palette.warning }}
      contractStateProps={contractStateProps}
    />
  )
}

export default InexogyDetails
